import React from 'react'
import {Link} from 'gatsby'
import tw from 'twin.macro'

const InternalLink = tw(Link)`text-blue-900 hocus:text-blue-700 font-bold`
const ExternalLink = tw.a`text-blue-900 hocus:text-blue-700 font-bold`

const AppLink = (props) => {
  if (props.to) {
    return <InternalLink {...props}/>
  } else {
    return <ExternalLink {...props}/>
  }
}

export default AppLink
